import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class TextAnnotationPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:TextAnnotation';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'textAnnotation',
        label: i18n.textAnnotation || 'Text Annotation',
        entries: [
          {
            id: 'annotationText',
            component: () => (
              <TextFieldEntry
                id="epx-annotation-text"
                label={i18n.text || 'Text'}
                value={props.text || ''}
                onChange={(val) => update('text', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
